import { POST } from '@/server/http';
import URLS from '@/server/urls';

export default async (params, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.dictionary.getCategories, params, options);
    if (error) return { error, status };
    return content || { rows: [] };
};
